/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `*,
*:focus,
:host(:focus) {
  outline: none;
}

/* default */
:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  width: 360px;
}
:host .label {
  font-size: inherit;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  line-height: calc(22rem /14);
}
:host .slider {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
  margin-right: calc(17rem /14);
  margin-left: 0;
}
:host .slotwrapper {
  order: 0;
  flex: 0 0 auto;
  align-self: auto;
  padding-right: calc(5rem /14);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host .icon {
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host .icon davinci-icon,
:host .icon davinci-icon-ref {
  font-size: 1rem;
}
:host .bar_container {
  width: 100%;
  margin: 0 calc(12rem /14);
  cursor: pointer;
  touch-action: none;
}
:host .bar_outer {
  margin-top: calc(15rem /14);
  flex: 1 1 auto;
  height: calc(2rem /14);
  width: 100%;
  border-radius: calc(100rem /14);
  background: #C5CACC;
  background: var(--davinci-color-outline-light, #C5CACC);
}
:host .bar_inner {
  height: calc(2rem /14);
  border-radius: calc(100rem /14);
  background: #007CC1;
  background: var(--davinci-color-primary, #007CC1);
}
:host .knob {
  position: relative;
  float: left;
  width: calc(16rem /14);
  height: calc(16rem /14);
  border-radius: 100%;
  transform: translate(-50%, -58%);
  background: #007CC1;
  background: var(--davinci-color-primary, #007CC1);
  z-index: 2;
}
:host .knob:after {
  content: "";
  position: absolute;
  top: calc(-16rem /14);
  bottom: calc(-16rem /14);
  left: calc(-16rem /14);
  right: calc(-16rem /14);
}
:host div[data-id="1"] {
  transform: translate(-150%, -58%);
}
:host .knob:hover .knob_shadow {
  width: calc(26rem /14);
  height: calc(26rem /14);
  margin: calc(-5rem /14) 0 0 calc(-5rem /14);
  border-radius: 100%;
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
  opacity: 0.2;
}
:host .knob.focused .knob_shadow,
:host .knob[data-id="1"].focused .knob_shadow,
:host .knob[data-id="0"].focused .knob_shadow {
  width: calc(26rem /14);
  height: calc(26rem /14);
  margin: calc(-5rem /14) 0 0 calc(-5rem /14);
  border-radius: 100%;
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
  opacity: 0.4;
}
:host .knob.pressed,
:host .knob[data-id="0"].pressed {
  transform: translate(-50%, -58%) scale(1.25);
}
:host .knob.pressed .knob_shadow,
:host .knob[data-id="0"].pressed .knob_shadow {
  width: calc(26rem /14);
  height: calc(26rem /14);
  margin: calc(-5rem /14) 0 0 calc(-5rem /14);
  border-radius: 100%;
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
  opacity: 0.2;
}
:host .knob[data-id="1"].pressed {
  transform: translate(-150%, -58%) scale(1.25);
}
:host .knob[data-id="1"].pressed .knob_shadow {
  width: calc(26rem /14);
  height: calc(26rem /14);
  margin: calc(-5rem /14) 0 0 calc(-5rem /14);
  border-radius: 100%;
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
  opacity: 0.2;
}
:host .knob:active {
  cursor: pointer;
  outline: none;
}
:host .touch_container {
  position: relative;
}
:host .value-bubble {
  display: none;
  float: left;
  position: absolute;
  transform: translate(-50%, calc(-51rem /14));
  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.4));
  z-index: 2;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  :host .value-bubble {
    transform: translate(-50%, -51px);
  }
}
:host .value-bubble.knob_pressed, :host .value-bubble.knob_hover {
  display: block;
}
:host .value-bubble .value-bubble-clip-path {
  background-color: #e5f1f8;
  background-color: var(--davinci-color-information-light, #e5f1f8);
  color: #2C3133;
  color: var(--davinci-color-text-on-information-light, #2C3133);
  text-align: center;
  padding: calc(5rem /14) calc(12rem /14) calc(13rem /14);
}
:host .legend {
  position: relative;
  width: 100%;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
:host .verticalLines {
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  margin-top: calc(4rem /14);
  margin-bottom: calc(2rem /14);
}
:host .verticalLine {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  float: left;
  width: calc(1rem /14);
  height: calc(12rem /14);
  background: #C5CACC;
  background: var(--davinci-color-outline-light, #C5CACC);
  border: none;
  border-radius: calc(100rem /14);
}
:host .values {
  position: relative;
  width: 100%;
}
:host .value {
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  left: 50%;
  margin-top: calc(14rem /14);
  max-width: 32%;
  overflow: hidden;
  position: absolute;
  text-align: center;
  text-overflow: ellipsis;
  transform: translate(-50%, 0);
  white-space: nowrap;
}
:host .value.left {
  left: calc(-4rem /14);
  text-align: left;
  transform: none;
}
:host .value.right {
  left: calc(100% + 4rem /14);
  text-align: right;
  transform: translate(-100%, 0);
}
:host .slider-wrapper,
:host .value-fields,
:host .slider {
  display: flex;
}
:host .slider-wrapper,
:host .slider {
  flex-grow: 1;
}
:host .value-field:nth-child(2) {
  margin-left: calc(17rem /14);
}
:host .noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

:host([legend=true]) {
  padding-bottom: calc(15rem /14);
  padding-top: calc(15rem /14);
}

:host([disabled]) {
  pointer-events: none;
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .icon {
  fill: #C5CACC;
  fill: var(--davinci-color-outline-light, #C5CACC);
}
:host([disabled]) .bar_container,
:host([disabled]) .knob {
  cursor: default;
}
:host([disabled]) .bar_inner,
:host([disabled]) .knob {
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
  box-shadow: none !important;
}
:host([disabled]) .verticalLine {
  background: #C5CACC;
  background: var(--davinci-color-outline-light, #C5CACC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
